import { isAxiosError } from 'axios'
import { isObject, values } from 'lodash/fp'

import getErrorMessage from '@/core/utils/http/getErrorMessage'

export const queryErrorHandler = (error: unknown) => {
  const message = isAxiosError(error) ? getErrorMessage(error) : undefined

  if (message) {
    if (isObject(message)) {
      return values(message)[0]
    }

    return message
  }

  return undefined
}
